<template>
  <p>
    Your login does not have access to this page.
  </p>
</template>

<script>
export default {
  name: 'accessDenied'
};
</script>

<style scoped>
p {
    font-weight: bold;
    font-size: 50px;
    text-align: center;
    color: #f10b0b;
}
</style>



// WEBPACK FOOTER //
// src/components/error-pages/accessDenied.vue